<template>
  <Toast/>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="listeMarqueModeleFiltrer"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          selectionMode="single"
          dataKey="cleModele"
          :paginator="true"
          :rows="10"
          sort-field="cleModele"
          :sortOrder="-1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} modèles"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="cleModele"
            header="Clé"
            :sortable="true"
        ></Column>
        <Column field="cleMarque" header="Marque" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <Dropdown class="dropdown-height"
                          v-model="data[field]"
                          :options="marqueLibelles"
                          optionValue="valeur"
                          optionLabel="texte"
                          scrollHeight="205px"
                          :showClear="true"/>
              </div>
            </div>
          </template>
        </Column>
        <Column field="texteModele" header="Modèle" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';
import DialogConfirmation from '../../../Commun/DialogConfirmation.vue';

export default {
  props: ['listeMarqueModeleFiltrer', 'marqueLibelles', 'isRechercheDataLoading'],
  emits: ['removeModeleFromList'],
  components: {
    DialogConfirmation
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      modeleToDelete: {},
    }
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  methods: {
    confirmerSuppression(data) {
      this.modeleToDelete = {
        cle: data.cleModele, cleMarque: data.cleMarque, texte: data.texteModele
      };
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer le modele?",
        accept: () => {
          return this.supprimer();
        },
        reject: () => {
        },
      })
    },
    supprimer() {
      this.$store.dispatch('pilotage/supprimerModeleAction', {modeleVehiculeVO: this.modeleToDelete})
          .then((res) => {
            if (res?.data?.messageVOs.length == 0) {
              this.$toast.add({
                severity: 'success',
                summary: 'Suppression Modèle',
                detail: "La suppression a été effectuée",
                life: 6000
              });
              this.$emit("removeModeleFromList", this.modeleToDelete.cle);
            } else {
              this.$root.$refs.messagesComp.messagesList = res.data.messageVOs;
            }
          });
    },
    sauvegarder(data) {
      let modeleVehiculeVO = {
        cle: data.cleModele, cleMarque: data.cleMarque, texte: data.texteModele
      };
      this.$store.dispatch('pilotage/modifierModeleAction', {
        modeleVehiculeVO: modeleVehiculeVO
      }).then(() => {
        this.$toast.add({
          severity: 'success',
          summary: 'Modification Modèle',
          detail: 'La modification a été effectuée',
          life: 6000
        });
      });
    },
  },
}
</script>
